import { jsx as _jsx } from "react/jsx-runtime";
import { ClipStatus, ClipType } from "@air/api/types";
import { memo } from "react";
import { ProcessingVersionThumbnail } from "./components/ProcessingVersionThumbnail";
import { VersionFileThumbnail } from "./components/VersionFileThumbnail";
import { VersionImageThumbnail } from "./components/VersionImageThumbnail";
export const VersionListItemThumbnail = /*#__PURE__*/ memo((param)=>{
    let { type, status, src, ext, isCurrentVersion } = param;
    if (type === ClipType.nonMedia || status === ClipStatus.failed || status === ClipStatus.nonTranscodable) {
        return /*#__PURE__*/ _jsx(VersionFileThumbnail, {
            ext: ext,
            isCurrentVersion: isCurrentVersion
        });
    }
    if (src) {
        return /*#__PURE__*/ _jsx(VersionImageThumbnail, {
            src: src,
            isCurrentVersion: isCurrentVersion
        });
    }
    return /*#__PURE__*/ _jsx(ProcessingVersionThumbnail, {
        isCurrentVersion: isCurrentVersion
    });
});
VersionListItemThumbnail.displayName = "VersionListItemThumbnail";
